var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoans = function SvgLoans(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M9 19H5v2h4zM9 16H5v2h4zM9 13H5v2h4zM9 10H5v2h4zM4 19H0v2h4zM4 16H0v2h4zM23.7 19.3l-.7-.7v-8.1c-.2-2.5-2-4.6-4.3-5.3l2.2-3.7L20 0h-6l-.9 1.5 2.2 3.7c-2.4.7-4.1 2.7-4.3 5.3v8.1l-.7.7.7 1.7h12zM18.2 2 17 4.1 15.8 2zM21 19h-8v-8c0-2.2 1.8-4 4-4s4 1.8 4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M17 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgLoans;